// AUTO-GENERATED — provides `React` and `ReactDOM` as injected
// imports for legacy JSX files that reference them as free globals.
import * as React from "react";
// react-dom@18 ships createRoot under react-dom/client; app.jsx
// expects to call ReactDOM.createRoot on this namespace.
import * as ReactDOM from "react-dom/client";
export { React, ReactDOM };
